import React from 'react'
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next'
import BannerForm from 'components/presenter/form/banner/BannerForm'
import BannerFormContent from 'components/presenter/form/banner/BannerFormContent'
import FillButton from 'components/presenter/buttons/FillButton'
import cn from 'classnames'
import Page from 'components/presenter/page/Page'
import * as styles from './success.module.css'


const CreateCompanySuccessPage = () => {
  const { t } = useTranslation()
  const { navigate } = useI18next()

  const redirect = () => {
    navigate('/jetso/')
  }
  
  return (
    <Page>
      <BannerForm>
        <BannerFormContent
          title={t('createCompanySuccess.title')}
          subTitle={t('createCompanySuccess.description')}
        >
          <FillButton
            className={cn(styles.btnPost)}
            onClick={redirect}
          >
            {t('common.postJetso')}
          </FillButton>
        </BannerFormContent>
      </BannerForm>
    </Page>
  )
}

export default CreateCompanySuccessPage